import { useTranslation } from 'react-i18next';

import { IntegrationCard } from '~features/integrations/IntegrationCard';

import { useConnectInstagram } from '../model/useConnectInstagram';
import { useDisconnectInstagram } from '../model/useDisconnectInstagram';
import { useGetInstagramAccount } from '../model/useGetInstagramAccount';
import { InstagramLogo } from './InstagramLogo';

type InstagramCardProps = {
  pharmacyId: string;
};

export function InstagramCard({ pharmacyId }: InstagramCardProps) {
  const { t } = useTranslation();

  const { account } = useGetInstagramAccount(pharmacyId);
  const {
    mutate: connect,
    isPending: isConnecting,
    cancelCount,
  } = useConnectInstagram(pharmacyId);
  const { mutate: disconnect, isPending: isDisconnecting } =
    useDisconnectInstagram(pharmacyId);

  const isConnected = account?.isTokenExpired === false;

  const isPending = isConnecting || isDisconnecting;

  const handleToggle = () => {
    if (isPending) {
      return;
    }

    if (isConnected) {
      disconnect();
    } else {
      connect();
    }
  };

  return (
    <IntegrationCard
      identity={{
        logo: <InstagramLogo />,
        name: 'Instagram',
      }}
      pending={{
        isPending,
        label: isConnecting
          ? t('integrations instagram connecting')
          : undefined,
      }}
      switchProps={{
        key: cancelCount.current,
        checked: isConnected,
        onCheckedChange: handleToggle,
      }}
    />
  );
}
